export default __webpack_public_path__ + "static/media/Gyre of the Judgment Bolt.03632dc1.jpg";